import React from 'react';
import {
  ContentColors,
  Flex,
  IconCustomerService,
  Typography,
} from '@banhala/ui-kit';

export const PocEmpty = () => {
  return (
    <Flex.Column
      flex={1}
      gap={16}
      margin={{ top: 32, bottom: 38 }}
      alignItems="center"
    >
      <IconCustomerService
        width={96}
        height={96}
        fill={ContentColors.content_tertiary}
      />
      <Typography type="body2" color="content_secondary">
        등록된 연락처가 없어요
      </Typography>
    </Flex.Column>
  );
};
